const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** ~2.5 weeks between order placement and issue report. */
export const ORDER_TO_REPORT_DAYS = 18;

export const DISPUTE_WINDOW_DAYS = 10;

/** Days after report when the return label is scanned (returns required). */
export const RETURN_SCAN_DAYS = 10;

/** Days after report when the return is marked delivered (returns required). */
export const RETURN_DELIVERED_DAYS = 20;

/** Return window after a report is submitted when returns are required. */
export const RETURN_WINDOW_DAYS = 30;

export const startOfDay = (date: Date): Date => {
  const normalized = new Date(date);
  normalized.setHours(0, 0, 0, 0);
  return normalized;
};

export const addDays = (date: Date, days: number): Date =>
  new Date(date.getTime() + days * MS_PER_DAY);

export const subtractDays = (date: Date, days: number): Date =>
  addDays(date, -days);

export const formatPrototypeDate = (date: Date): string =>
  date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

export const formatPrototypeDateShort = (date: Date): string =>
  date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
  });

export const formatPrototypeMonthDay = (date: Date): string =>
  date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
  });

export const getPrototypeToday = (): Date => startOfDay(new Date());

export type PrototypeIssueDates = {
  orderDate: Date;
  dateReported: Date;
  disputeDeadline: Date;
  orderDateSort: number;
  dateReportedSort: number;
};

export const computeDatesFromDaysLeftToDispute = (
  today: Date,
  daysLeftToDispute: number
): PrototypeIssueDates => {
  const disputeDeadline = addDays(startOfDay(today), daysLeftToDispute);
  const dateReported = subtractDays(disputeDeadline, DISPUTE_WINDOW_DAYS);
  const orderDate = subtractDays(dateReported, ORDER_TO_REPORT_DAYS);

  return {
    orderDate,
    dateReported,
    disputeDeadline,
    orderDateSort: orderDate.getTime(),
    dateReportedSort: dateReported.getTime(),
  };
};

export const computeDatesFromDaysSinceReported = (
  today: Date,
  daysSinceReported: number
): PrototypeIssueDates => {
  const dateReported = subtractDays(startOfDay(today), daysSinceReported);
  const disputeDeadline = addDays(dateReported, DISPUTE_WINDOW_DAYS);
  const orderDate = subtractDays(dateReported, ORDER_TO_REPORT_DAYS);

  return {
    orderDate,
    dateReported,
    disputeDeadline,
    orderDateSort: orderDate.getTime(),
    dateReportedSort: dateReported.getTime(),
  };
};

export const buildPinewoodOrderStatusTimeline = (orderDate: Date) => [
  {
    label: "Delivered",
    date: formatPrototypeDate(addDays(orderDate, 14)),
    completed: true,
  },
  {
    label: "Shipped",
    date: formatPrototypeDate(addDays(orderDate, 9)),
    completed: true,
  },
  {
    label: "Accepted",
    date: formatPrototypeDate(addDays(orderDate, 2)),
    completed: true,
  },
  {
    label: "Received",
    date: formatPrototypeDate(orderDate),
    completed: true,
  },
];
